module.exports = {
    exclude:
        '/(?:dealers/(?:todo_iframe|bulk_shipping|bulk-return-policies|dashboard_modal|bulk-repost-items|move-to-storefront))',
    optionsData: {
        min_cta: 'Give Us Your Feedback',
    },
};
